import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'manage-fiche-consultation',
    components: {},
    props: {
        selected_consultation: Object,
        info_user: Object,
        modal_toggler: Number,
        selected_fiche: {
            type: Object, 
            default: () => ({})
        },
        liste_sections: {
            type: Array,
            default: () => ([])
        },
        fiche_consultations: {
            type: Array,
            default: () => ([])
        },
    },
    data() {
        return {
            section_loading: true,
            fiche_data: {
                libelle: ""
            },

            select_all: '',
            checked_sections: [],
            all_checked: false,
            one_is_checked: [],
            save_loading: false,
            is_error: false,
            err_message: "",
            fiche_id: 0,

            default_fiche: ''
        }
    },

    watch: {
        modal_toggler() {
            this.fiche_data.libelle = ""
            this.one_is_checked = []
            this.err_message = ""

            if (Object.prototype.hasOwnProperty.call(this.selected_fiche, 'libelle')) {
                this.autoFillFields()
            }

            this.setDefaultFiche()
        }
    },

    computed: {
        default_consultation_sections(){
            return this.$store.getters["default_consultation_sections"];
        },
    },

    mounted() {
        this.listeDefaultConsultationSection()
    },

    methods: {
        listeDefaultConsultationSection() {
            this.section_loading = true
            let data = {
                is_default: 0,
                can_show: 1
            }
            this.$store.dispatch('getDefaultConsultationSections', data).then(() => {
                this.section_loading = false
            })
        },

        setDefaultFiche() {
            const default_item = this.fiche_consultations.find(f => f.statut === 1);
            if (default_item) {
                this.default_fiche = default_item.id;
            }

            console.log("mm");
        },

        toutSelectionner() {
            let is_checked = $('#section-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.default_consultation_sections.forEach((data) => {
                    this.one_is_checked.push(data.id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            document.getElementById("section-tous").checked = false;
        },

        async save() {
            this.err_message = ""
            const isValid = await this.$refs.fiche_form.validate();
            if (!isValid) {
                return;
            }

            let data = {
                fiche_consultation_id: this.fiche_id,
                fiche_consultation: this.fiche_data.libelle,
                sections: this.one_is_checked,
                type_consultation_id: this.selected_consultation.id,
                info_user: this.info_user
            }

            this.save_loading = true
            store_fiche.saveFicheConsultation(data).then((response) => {
                if (response.success && response.code == 200) {
                    this.fiche_data.libelle = ""
                    this.one_is_checked = []
                    this.$refs.n_fiche.click()
                    this.successToast(response.message)

                    this.$emit('emitFicheConsultation')
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.n_fiche.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        autoFillFields() {
            this.fiche_id = this.selected_fiche.id
            this.fiche_data.libelle = this.selected_fiche.libelle

            if (this.liste_sections.length > 0) {
                this.liste_sections.forEach((defined_section) => {
                    this.default_consultation_sections.forEach((section) => {
                        if (defined_section.section_id == section.id && defined_section.etat == 1) {
                            this.one_is_checked.push(section.id)
                        }
                    });
                })
            }
        }, 

        saveDefaultFiche() {
            const data = {
                type_consultation_id: this.selected_consultation.id,
                default_fiche_id: this.default_fiche
            }
            this.save_loading = true
            
            store_fiche.saveDefaultFicheConsultation(data).then((response) => {
                if (response.success) {
                    this.$refs.c_default.click()
                    this.successToast(response.message)

                    this.$emit('emitFicheConsultation')
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.c_default.click()
                this.errorToast("Une erreur s'est produite !")
            })
        }
    }
}